import { FormControl, InputLabel, NativeSelect } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FilterButton } from '@care/react-component-lib';
import { Icon24UtilityChevron } from '@care/react-icons';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { PAY_RATES, PAY_RATES_JOB } from '@/constants';
import { saveFilters } from '../../../utils/filtersStorage';

interface PayRateProps {
  isClear: Boolean;
  onChange(): void;
  handleClick(): void;
  isJobSearch: boolean;
}

const PayRate = (props: PayRateProps) => {
  const { handleClick, isClear, onChange, isJobSearch } = props;
  const [payRate, setPayRate] = useState({
    hourlyRate: '',
  });

  const iconComponent = () => (
    <Icon24UtilityChevron component="select" height="20px" width="20px" />
  );

  const handleApply = () => {
    saveFilters(
      {
        hourlyRate: payRate.hourlyRate,
      },
      onChange
    );

    const amplitudeData = {
      hourlyRate: payRate.hourlyRate,
    };

    trackAmplitudeEvent(AmplitudeEvent.applySegmentationFilter, amplitudeData);
  };

  useEffect(() => {
    if (isClear) {
      setPayRate({
        hourlyRate: '',
      });
    }
  }, [isClear]);

  const renderPayRate = () => {
    if (isJobSearch) {
      return PAY_RATES_JOB;
    }
    return PAY_RATES;
  };

  return (
    <FilterButton
      field="Pay Rate"
      label="Pay Rate"
      selected={Boolean(payRate.hourlyRate)}
      onApply={handleApply}
      onClick={handleClick}>
      <FormControl variant="standard" sx={{ width: '325px' }}>
        <InputLabel htmlFor="demo-native-select">
          {isJobSearch ? 'RATE PER HOUR' : 'COST PER HOUR'}
        </InputLabel>
        <NativeSelect
          fullWidth
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            setPayRate({ ...payRate, hourlyRate: e.target.value })
          }
          inputProps={{
            name: 'option',
            id: 'field-native-select',
          }}
          value={payRate.hourlyRate}
          IconComponent={iconComponent}>
          {renderPayRate().map((rate) => (
            <option key={rate.label} value={rate.value}>
              {rate.label}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
    </FilterButton>
  );
};

export default PayRate;
